
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jjJHb", function(module, exports) {
$parcel$export(module.exports, "Banner", () => (parcelRequire("3nSw9")).Banner);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $3nSw9 = parcelRequire("3nSw9");


});

parcelRegister("4d9tL", function(module, exports) {
module.exports = new URL("play-button.f16ed914.png", import.meta.url).toString();

});

parcelRegister("fNJwF", function(module, exports) {
module.exports = new URL("squiggle-dark.e67532b4.svg", import.meta.url).toString();

});

parcelRegister("cKGRx", function(module, exports) {
module.exports = new URL("squiggle-light.2010fbc8.svg", import.meta.url).toString();

});

parcelRegister("3nSw9", function(module, exports) {
/* Banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cO1el = parcelRequire("cO1el");


var $cOrQJ = parcelRequire("cOrQJ");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");

/* VideoButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");







var $6F6hl = parcelRequire("6F6hl");




var $fVUfS = parcelRequire("fVUfS");


var $gj7hi = parcelRequire("gj7hi");

var $840975e2edcb553e$exports = {};
$840975e2edcb553e$exports = new URL("banner-thumbnail-light.59f4131f.png", import.meta.url).toString();


var $b0d321abfca871dc$exports = {};
$b0d321abfca871dc$exports = new URL("banner-thumbnail-dark.09dc32c3.png", import.meta.url).toString();



var $4d9tL = parcelRequire("4d9tL");

const $b7aac35de5008721$var$messages = (0, $cgtv4.defineMessages)({
    playNow: {
        id: "modernize-confluence-ipm-modal.playNow",
        defaultMessage: "Play video"
    }
});
const $b7aac35de5008721$var$styles = {
    videoButton: "_1bsbr0r7 _16jlidpf _1o9zidpf _i0dlr0r7 _kqswh2mm _1wpz1fhb",
    thumbnail: "_kqswstnw _1ltvx0bf _1bsbp3fh",
    button: "_2rko1rr0 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _1bsb8vuz",
    buttonWrapper: "_kqswstnw _154i1ejb _1ltvidpf _1xi2idpf _1e0c1txw _1bah1h6o _4cvr1h6o",
    playImg: "_1e0c1ule _p12f1osq _4t3i1wug"
};
const $b7aac35de5008721$export$8cfa4a1a1446c6bc = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $b7aac35de5008721$var$styles.videoButton
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $b7aac35de5008721$var$styles.thumbnail
    }, /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($840975e2edcb553e$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b0d321abfca871dc$exports)))
    }), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $b7aac35de5008721$var$styles.buttonWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: $b7aac35de5008721$var$styles.button,
        onClick: onClick
    }, /*#__PURE__*/ $42omo.createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4d9tL))),
        className: (0, $gMc0m.default)([
            $b7aac35de5008721$var$styles.playImg
        ])
    }), /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), null, formatMessage($b7aac35de5008721$var$messages.playNow))))));
};


const $31c5fc7ddb24a1a8$var$styles = {
    banner: "_2rko12b0 _1reo15vq _18m915vq _1h6d1l7x _189ee4h9 _1dqonqa1 _bfhkhfxm",
    text: "_1ul91mjv _p12f1kdj",
    closeWrapper: "_1wpz1y6m",
    blue: "_syaz1oa5 _o5721q9c",
    underline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _n3tdv47k _12vemgnk _uokl1nrf _1lrw1f51",
    content: "_1rjcpxbi _16jlkb7n _1n261g80",
    spacer: "_16jlkb7n _1bahesu3"
};


const $31c5fc7ddb24a1a8$var$Underlined = ({ children: children })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // Ensure the theme is observed for styling
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $31c5fc7ddb24a1a8$var$styles.underline,
        as: "u",
        style: {
            backgroundImage: `url(${colorMode === 'dark' ? (parcelRequire("fNJwF")) : (parcelRequire("cKGRx"))})`
        }
    }, children);
};
const $31c5fc7ddb24a1a8$export$3b4e64e77073e307 = ({ onClick: onClick, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignInline: "center",
        alignBlock: "center",
        space: "space.100",
        spread: "space-between",
        xcss: $31c5fc7ddb24a1a8$var$styles.banner
    }, /*#__PURE__*/ $42omo.createElement((0, $b7aac35de5008721$export$8cfa4a1a1446c6bc), {
        onClick: onClick
    }), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        xcss: $31c5fc7ddb24a1a8$var$styles.content,
        alignBlock: "center",
        space: "space.100",
        rowSpace: "space.150",
        spread: "space-between"
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        xcss: $31c5fc7ddb24a1a8$var$styles.text,
        space: "space.050"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "large"
    }, formatMessage($31c5fc7ddb24a1a8$var$messages.heading, {
        u: (parts)=>/*#__PURE__*/ $42omo.createElement($31c5fc7ddb24a1a8$var$Underlined, null, parts),
        b: (parts)=>parts,
        // backwards compatibility for old translations
        em: (parts)=>parts // backwards compatibility for old translations
    })), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, formatMessage($31c5fc7ddb24a1a8$var$messages.body)))), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        xcss: $31c5fc7ddb24a1a8$var$styles.spacer,
        space: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClick
    }, formatMessage($31c5fc7ddb24a1a8$var$messages.playNow)))), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $31c5fc7ddb24a1a8$var$styles.closeWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
        appearance: "subtle",
        label: formatMessage($31c5fc7ddb24a1a8$var$messages.dismissCta),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        onClick: onClose
    })));
};
const $31c5fc7ddb24a1a8$var$messages = (0, $cgtv4.defineMessages)({
    heading: {
        id: "modernize-confluence-ipm-modal.heading",
        defaultMessage: "Designed for <u>Collaboration</u>"
    },
    body: {
        id: "modernize-confluence-ipm-modal.body",
        defaultMessage: "We\u2019ve been adding capabilities to make Confluence the best tool for teams to brainstorm and bring ideas to life."
    },
    dismissCta: {
        id: "modernize-confluence-ipm-modal.dismissCta",
        defaultMessage: "Dismiss"
    },
    playNow: {
        id: "modernize-confluence-ipm-modal.playNow",
        defaultMessage: "Show me"
    }
});
module.exports["Banner"] = $31c5fc7ddb24a1a8$export$3b4e64e77073e307;

});


//# sourceMappingURL=Banner.85bc7eea.js.map
